<template>
  <div class="rui-drawer" :class="componentCss">
    <rui-overlay v-if="overlay" :disabled="!overlayCloseable" @click="handleClickOnOverlay" />
    <div class="rui-drawer__widget">
      <h2 v-if="caption || $slots.caption" class="rui-drawer__title">
        <span class="rui-drawer__title__content">
          <!-- @slot Title slot. Will override `caption` prop -->
          <slot name="caption">{{ caption }}</slot>
        </span>
        <rui-button v-if="closeable"
                    icon="rui:x-bold"
                    class="fr"
                    text
                    :title="$t('rui.generic.close')"
                    @click="close" />
      </h2>
      <div v-if="$slots.actions" ref="actions" class="rui-drawer__actions">
        <!-- @slot Actions slot -->
        <slot name="actions" />
      </div>
      <div class="rui-drawer__content" :style="contentStyle">
        <!-- @slot Drawer content -->
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
import RuiOverlay from '../Utils/Overlay/Overlay.vue'
import RuiButton from '../Button/Button.vue'

/**
 * Side drawer, above an overlay.
 *
 * @noPlayground
 * @propsGroup Display  [position, overlay]
 * @propsGroup Behavior [closeable, overlayCloseable]
 * @propsGroup Content  [caption]
 */
export default {
  name: 'RuiDrawer',
  emits: [
    'close',
  ],
  components: { RuiButton, RuiOverlay },
  props: {
    /** Drawer title, if any */
    caption: { required: false, type: String, default: null },
    /** Docking position */
    position: { required: false, type: String, default: 'left' },
    /** Whether to display a "close" button and handle overlay click */
    closeable: { required: false, type: Boolean, default: true },
    /** When set, defines if a click on the overlay closes the drawer */
    overlayCloseable: { required: false, type: Boolean, default (props) { return props.closeable } },
    /** Whether to display the overlay */
    overlay: { required: false, type: Boolean, default: true },
  },
  data () {
    return {
      actionsHeight: 0,
    }
  },
  computed: {
    componentCss () {
      return {
        'rui-drawer--left': this.position === 'left',
        'rui-drawer--right': this.position === 'right',
      }
    },
    contentStyle () {
      return {
        height: `calc(100vh  - var(--drawer-title-height) - ${this.actionsHeight}px)`,
      }
    },
  },
  methods: {
    close () {
      if (!this.$props.closeable) return

      this.$emit('close')
    },
    handleClickOnOverlay () {
      if (this.$props.overlayCloseable) this.close()
    },
  },
  mounted () {
    const actionsRef = this.$refs.actions
    if (actionsRef) {
      this.actionsHeight = actionsRef.offsetHeight
    }
  },
}
</script>
